import React from 'react'
import { telecomunication } from '../../translate'
import ShortInfoCard from '../ShortInfoCard'
import { useNavigate } from 'react-router-dom'
export default function Telecomunication() {
    const navigate = useNavigate()
    return (
        <div>
            <h3 style={{ margin: '20px 20px' }}>{telecomunication.title[+localStorage.getItem('atsLang') || 1]}</h3>
            <div className="short-cards" >
                <ShortInfoCard
                    label="Telegram"
                    description={telecomunication.telegram[+localStorage.getItem('atsLang') || 1]}
                    onEdit={() => { navigate('/short_function/connect/telegram') }}
                >
                    <span />
                </ShortInfoCard>
                <ShortInfoCard
                    label="WhatsApp"
                    description={telecomunication.whatsapp[+localStorage.getItem('atsLang') || 1]}
                    onEdit={() => { navigate('/short_function/connect/whatsapp') }}
                >
                    <span />
                </ShortInfoCard>
            </div>
        </div>
    )
}
